import { API } from '@/inc/api';
import { _st } from '@/softech';
import { bus } from '@/main';

export const pickupLocations = {
    namespaced: true,
    state: {
        pickupLocations : [],
        needRefresh     : true,
    },
    mutations: {
        setPickupLocations( state, payload ) {
            state.pickupLocations = payload;
        },
        setNeedRefresh( state, payload ) {
            state.needRefresh = payload;
        }
    },
    actions: {
        async loadPickupLocations({ commit, state }) {
            if( !state.needRefresh ) {
                return Promise.resolve();
            }

            try {
                let api = new API();
                let res = await api.get('/admin/pickup-locations');

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text    : res.data.message, 
                        color   : res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject( false );
                }

                commit('setPickupLocations', res.data.data);
                commit('setNeedRefresh', false);
                return Promise.resolve();
            }
            catch(error) {
                return Promise.reject(error);
            }
        },
        async savePickupLocations({ commit }, product) {
            try {
                let api = new API();
                let res = null;
                
                if( _st.isNUE( product.id ) )
                    res = await api.post('/admin/pickup-locations', product);
                else
                    res = await api.put('/admin/pickup-locations', product);

                if( !res.data.status ) {
                    return Promise.resolve( res.data );
                }

                commit('setNeedRefresh', true);
                return Promise.resolve( res.data );
            }
            catch(error) {
                return Promise.reject(error);
            }
        }
    },
    getters: {
        pickupLocations : (state) => state.pickupLocations,
        needRefresh     : (state) => state.needRefresh,
    }
}